export default __webpack_public_path__ + "static/media/AntyLucy_22.4c66637b.jpg";